import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'login',
    },
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('@/view/login'),
    meta: {
      title: '用户登录',
      keepAlive:false,
      noLogin:true,
    },
  },
  {
    name: 'index',
    path: '/index',
    component: () => import('@/view/index'),
    meta: {
      title:'首页',
      keepAlive:true,
    },
  },
  {
    name: 'cart',
    path: '/cart',
    component: () => import('@/view/cart'),
    meta: {
      title: '购物车',
      keepAlive:true,
    },
  },
  {
    name: 'submit',
    path: '/submit',
    component: () => import('@/view/submit'),
    meta: {
      title: '提交订单',
      keepAlive:false,
    },
  },
  {
    name: 'goods',
    path: '/goods',
    component: () => import('@/view/goods'),
    meta: {
      title: '商品列表',
      keepAlive:true,
    },
  },
  {
    name: 'gshow',
    path: '/goods/show',
    component: () => import('@/view/goods/show'),
    meta: {
      title: '商品详情',
      keepAlive:true,
    },
  },
  {
    name: 'search',
    path: '/goods/search',
    component: () => import('@/view/goods/search'),
    meta: {
      title: '商品搜索',
      keepAlive:true,
    },
  },
  {
    name: 'news',
    path: '/news',
    component: () => import('@/view/news'),
    meta: {
      title: '公告',
      keepAlive:true,
    },
  },
  {
    name: 'nshow',
    path: '/news/show',
    component: () => import('@/view/news/show'),
    meta: {
      title: '公告详情',
      keepAlive:true,
    },
  },
  {
    name: 'user',
    path: '/user',
    component: () => import('@/view/user'),
    meta: {
      title: '会员中心',
      keepAlive:true,
    },
  },
  {
    name: 'money',
    path: '/user/money',
    component: () => import('@/view/user/money'),
    meta: {
      title: '修改密码',
      keepAlive:true,
    },
  },
  {
    name: 'password',
    path: '/user/password',
    component: () => import('@/view/user/password'),
    meta: {
      title: '修改密码',
      keepAlive:true,
    },
  },
  {
    name: 'uinfo',
    path: '/user/info',
    component: () => import('@/view/user/info'),
    meta: {
      title: '修改用户信息',
      keepAlive:true,
    },
  },
  {
    name: 'address',
    path: '/address',
    component: () => import('@/view/address'),
    meta: {
      title: '收货地址',
      keepAlive:true,
    },
  },
  {
    name: 'addedit',
    path: '/address/edit',
    component: () => import('@/view/address/edit'),
    meta: {
      title: '修改收货地址',
      keepAlive:true,
    },
  },
  {
    name: 'order',
    path: '/order',
    component: () => import('@/view/order'),
    meta: {
      title: '我的订单',
      keepAlive:true,
    },
  },
  {
    name: 'ordershow',
    path: '/order/show',
    component: () => import('@/view/order/show'),
    meta: {
      title: '订单详情',
      keepAlive:true,
    },
  },
  {
    name: 'refund',
    path: '/refund',
    component: () => import('@/view/refund'),
    meta: {
      title: '我的退货',
      keepAlive:true,
    },
  },
  {
    name: 'refundshow',
    path: '/refund/show',
    component: () => import('@/view/refund/show'),
    meta: {
      title: '退货详情',
      keepAlive:true,
    },
  },
  {
    name: 'recharge',
    path: '/recharge',
    component: () => import('@/view/recharge'),
    meta: {
      title: '我的充值',
      keepAlive:true,
    },
  },
  {
    name: 'redit',
    path: '/recharge/edit',
    component: () => import('@/view/recharge/edit'),
    meta: {
      title: '提交充值',
      keepAlive:true,
    },
  },
  {
    name: 'rshow',
    path: '/recharge/show',
    component: () => import('@/view/recharge/show'),
    meta: {
      title: '充值详情',
      keepAlive:true,
    },
  },
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('bntoken')||"";
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title+"_云烫鲜·订货系统";
  }
  if(to.meta.noLogin){
    next();
  }else{
    //console.log(token);
    //console.log("需要登录");
    if(token&&token!=""){
      next();
    }else{
      //console.log("跳转呀");
      next("/login");
    }
  }
});

export { router };
